import React from 'react';
import { useLocation } from 'react-router-dom';

const stripTrailingSlash = (path) => path.length > 1 ? path.replace(/\/+$/, '') : path;

const LandingSidebar = ({title, links}) => {
    const location = useLocation();

    return (
        <section
            className="pt-2 border-gray-200 lg:block lg:col-span-2 2xl:col-span-2 pb-24 pr-6 border-r border-t border-gray-100">
            <div className="flex flex-wrap flex-col xl:flex-row mb-5 border-b border-gray-100 pb-3">
                <nav aria-label={title}>
                    {title &&
                        <div className="text-sm font-semibold leading-tight text-gray-800 mb-2">{title}</div>}
                    <ul className="space-y-1">
                        {links.map((link, index) => {
                            const isActive = stripTrailingSlash(location.pathname) === stripTrailingSlash(link.to);
                            return (
                                <li key={index}>
                                    <a href={link.to}
                                       className={`block text-sm no-underline dropdown-menu-text dark:text-blue-400 dark:hover:text-gray-400 ${isActive ? 'font-semibold' : 'font-normal hover:text-red-700'}`}>
                                        {link.label}
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                </nav>
            </div>
        </section>
    );
};

export default LandingSidebar;
